import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createVNode as _createVNode, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card px-2 py-1" }
const _hoisted_2 = {
  key: 0,
  class: "gorda-table-header"
}
const _hoisted_3 = { class: "d-flex align-items-center gap-2" }
const _hoisted_4 = { class: "gorda-table-header-title mb-0" }
const _hoisted_5 = { class: "gorda-table-header-count" }
const _hoisted_6 = {
  key: 1,
  class: "gorda-table-loading-indicator"
}
const _hoisted_7 = { class: "text-secondary text-xs" }
const _hoisted_8 = { class: "table-responsive" }
const _hoisted_9 = { class: "table table-sm table-borderless align-items-center mb-0" }
const _hoisted_10 = { class: "text-uppercase text-secondary text-xxs font-weight-bolder ps-2" }
const _hoisted_11 = { class: "text-uppercase text-secondary text-xxs font-weight-bolder ps-2" }
const _hoisted_12 = { class: "text-uppercase text-secondary text-xxs font-weight-bolder ps-2" }
const _hoisted_13 = {
  key: 0,
  class: "text-uppercase text-secondary text-xxs font-weight-bolder ps-2"
}
const _hoisted_14 = { class: "text-uppercase text-secondary text-xxs font-weight-bolder ps-2" }
const _hoisted_15 = { class: "text-uppercase text-secondary text-xxs font-weight-bolder ps-2" }
const _hoisted_16 = { class: "text-uppercase text-secondary text-xxs font-weight-bolder ps-2" }
const _hoisted_17 = {
  class: "text-uppercase text-secondary text-xxs font-weight-bolder ps-2 text-center",
  style: {"width":"1%","white-space":"nowrap"}
}
const _hoisted_18 = {
  key: 1,
  class: "text-uppercase text-secondary text-xxs font-weight-bolder ps-2"
}
const _hoisted_19 = {
  key: 2,
  class: "text-uppercase text-secondary text-xxs font-weight-bolder ps-2"
}
const _hoisted_20 = {
  key: 3,
  class: "text-uppercase text-secondary text-xxs font-weight-bolder ps-2"
}
const _hoisted_21 = { class: "text-secondary font-weight-bolder opacity-7 text-center position-relative" }
const _hoisted_22 = ["title"]
const _hoisted_23 = { class: "py-1 col-1" }
const _hoisted_24 = { class: "py-1" }
const _hoisted_25 = { class: "py-1" }
const _hoisted_26 = { class: "d-flex align-items-center" }
const _hoisted_27 = ["title"]
const _hoisted_28 = ["title", "onClick"]
const _hoisted_29 = {
  key: 0,
  class: "py-1"
}
const _hoisted_30 = { class: "py-1" }
const _hoisted_31 = { class: "py-1" }
const _hoisted_32 = {
  key: 0,
  class: "d-flex align-items-center gap-2"
}
const _hoisted_33 = { class: "gorda-name-avatar" }
const _hoisted_34 = { class: "py-1" }
const _hoisted_35 = {
  class: "d-flex align-items-center text-truncate",
  style: {"max-width":"160px"}
}
const _hoisted_36 = ["title"]
const _hoisted_37 = ["title", "onClick"]
const _hoisted_38 = { class: "py-1 text-center" }
const _hoisted_39 = ["title"]
const _hoisted_40 = {
  key: 1,
  class: "py-1"
}
const _hoisted_41 = { class: "d-flex px-2 py-0" }
const _hoisted_42 = ["src"]
const _hoisted_43 = { class: "d-flex flex-column justify-content-center" }
const _hoisted_44 = { class: "my-0 text-sm" }
const _hoisted_45 = { class: "text-xs text-secondary my-0" }
const _hoisted_46 = { key: 2 }
const _hoisted_47 = ["title"]
const _hoisted_48 = { key: 4 }
const _hoisted_49 = {
  key: 5,
  class: "py-1 col-1"
}
const _hoisted_50 = ["onClick", "title"]
const _hoisted_51 = ["onClick", "title", "disabled"]
const _hoisted_52 = ["title", "id"]
const _hoisted_53 = ["onClick", "title"]
const _hoisted_54 = ["onClick", "title"]
const _hoisted_55 = ["onClick", "title"]
const _hoisted_56 = { key: 1 }
const _hoisted_57 = ["colspan"]
const _hoisted_58 = {
  key: 0,
  class: "container-fluid mt-2"
}
const _hoisted_59 = {
  key: 1,
  class: "container-fluid mt-2"
}
const _hoisted_60 = { class: "modal-dialog" }
const _hoisted_61 = { class: "modal-content" }
const _hoisted_62 = { class: "modal-header" }
const _hoisted_63 = { class: "modal-title" }
const _hoisted_64 = { class: "modal-body" }
const _hoisted_65 = { class: "text-xs text-secondary mb-1" }
const _hoisted_66 = { class: "text-sm fw-bold mb-3" }
const _hoisted_67 = { class: "modal-footer" }
const _hoisted_68 = {
  type: "button",
  class: "btn btn-secondary",
  "data-bs-dismiss": "modal"
}
const _hoisted_69 = ["disabled"]
const _hoisted_70 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_71 = { class: "modal-dialog" }
const _hoisted_72 = { class: "modal-content" }
const _hoisted_73 = { class: "modal-header" }
const _hoisted_74 = { class: "modal-title" }
const _hoisted_75 = { class: "modal-body" }
const _hoisted_76 = { class: "text-xs text-secondary mb-1" }
const _hoisted_77 = { class: "text-sm fw-bold mb-3" }
const _hoisted_78 = ["placeholder"]
const _hoisted_79 = { class: "modal-footer" }
const _hoisted_80 = {
  type: "button",
  class: "btn btn-secondary",
  "data-bs-dismiss": "modal"
}
const _hoisted_81 = ["disabled"]
const _hoisted_82 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2",
  role: "status",
  "aria-hidden": "true"
}

import DateHelper from '@/helpers/DateHelper'
import ServiceHelper from '@/helpers/ServiceHelper'
import Paginator from '@/components/Paginator'
import Service from '@/models/Service'
import AutoComplete from '@/components/AutoComplete.vue'
import ClientCompletedBadge from '@/components/services/ClientCompletedBadge.vue'
import {onBeforeUnmount, onMounted, ref, Ref, watch, computed} from 'vue'
import {Modal, Tooltip} from 'bootstrap'
import {ServiceList} from '@/models/ServiceList'
import {Tables} from '@/constants/Tables'
import DBPaginator from '@/components/DBPaginator.vue'
import {Pagination} from '@/types/Pagination'
import {ServiceCursor} from '@/types/ServiceCursor'
import {AutoCompleteType} from '@/types/AutoCompleteType'
import {LocationType} from '@/types/LocationType'
import ServiceRepository from '@/repositories/ServiceRepository'
import ToastService from '@/services/ToastService'
import {usePlacesStore} from '@/services/stores/PlacesStore'
import {useSettingsStore} from '@/services/stores/SettingsStore'
import {storeToRefs} from 'pinia'
import {useI18n} from 'vue-i18n'


interface Props {
  services: Array<ServiceList>
  table: Tables
  pagination: Pagination
  loading?: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ServicesTable',
  props: {
    services: {},
    table: {},
    pagination: {},
    loading: { type: Boolean, default: false }
  },
  emits: [
  Service.EVENT_CANCEL,
  Service.EVENT_RELEASE,
  Service.EVENT_TERMINATE,
  'paginate',
  Service.EVENT_SHOW,
  Service.EVENT_RESTART
],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit
let interval: number
const paginatedServices: Ref<Array<ServiceList>> = ref(Array<ServiceList>())
const showDestination = computed(() => props.table === Tables.pendings)
const showDriverColumn = computed(() => props.table !== Tables.pendings)
const showDriverNameColumn = computed(() => props.table !== Tables.pendings && props.table !== Tables.inProgress && props.table !== Tables.history)
const showActionColumn = computed(() => true)
const visibleColumnCount = computed(() => {
  let count = 8 // #, hour, status, start_address, phone, name, comment, origin
  if (showDestination.value) count++
  if (showDriverColumn.value) count++
  if (showDriverNameColumn.value) count++
  if (showActionColumn.value) count++
  return count
})
const placesStore = usePlacesStore()
const { isReady: placesReady } = storeToRefs(placesStore)
const {branchSelected} = storeToRefs(useSettingsStore())
const placesAutocomplete: Ref<Array<AutoCompleteType>> = ref([])
const editingService: Ref<ServiceList | null> = ref(null)
const newStartLocation: Ref<LocationType | null> = ref(null)
const startLocationModalRef = ref<HTMLElement | null>(null)
let startLocationModal: Modal | null = null
const startLocationFieldKey = ref(0)
const isUpdatingStart = ref(false)
const editingCommentService: Ref<ServiceList | null> = ref(null)
const commentModalRef = ref<HTMLElement | null>(null)
let commentModal: Modal | null = null
const newComment = ref<string>('')
const isUpdatingComment = ref(false)
const { t } = useI18n()
const currentStartAddress = computed(() => {
  const name = editingService.value?.start_loc?.name
  return ServiceHelper.isSelfServiceStartLoc(name) ? t('services.self_service_trip') : name ?? 'N/A'
})
const currentComment = computed(() => editingCommentService.value?.comment ?? 'N/A')
const headerConfig = computed(() => {
  if (props.table === Tables.pendings) {
    return {
      gradient: 'linear-gradient(310deg,#f53939,#fbcf33)',
      icon: 'fa-clock',
      title: t('services.pending_title')
    }
  }
  return {
    gradient: 'linear-gradient(310deg,#2152ff,#21d4fd)',
    icon: 'fa-spinner',
    title: t('services.in_progress_title')
  }
})

watch(props.services, (newServices) => {
  paginatedServices.value = Array.from(newServices)
})

onMounted(() => {
  paginatedServices.value = Array.from(props.services)
  if(props.table !== Tables.history) interval = window.setInterval(getTime, 1000)
  if (startLocationModalRef.value) {
    startLocationModal = new Modal(startLocationModalRef.value)
    startLocationModalRef.value.addEventListener('hidden.bs.modal', resetStartLocationForm)
  }
  if (commentModalRef.value) {
    commentModal = new Modal(commentModalRef.value)
    commentModalRef.value.addEventListener('hidden.bs.modal', resetCommentForm)
  }
})

onBeforeUnmount(() => {
  window.clearInterval(interval)
  startLocationModalRef.value?.removeEventListener('hidden.bs.modal', resetStartLocationForm)
  commentModalRef.value?.removeEventListener('hidden.bs.modal', resetCommentForm)
})

function format(unix: number): string {
  return DateHelper.unixToDate(unix, 'MM-DD HH:mm:ss')
}

function cancel(service: Service, event?: Event): void {
  hideTooltip(event)
  emit(Service.EVENT_CANCEL, service.id)
}

function release(service: ServiceList, event?: Event): void {
  hideTooltip(event)
  service.driver = null
  emit(Service.EVENT_RELEASE, service)
}

function end(service: Service, event?: Event): void {
  hideTooltip(event)
  emit(Service.EVENT_TERMINATE, service.id)
}

function show(service: Service): void {
  emit(Service.EVENT_SHOW, service)
}

function restart(service: ServiceList, event?: Event): void {
  hideTooltip(event)
  emit(Service.EVENT_RESTART, service)
}

function applicantsCount(service: ServiceList): number {
  const applicants = service.applicants as unknown
  if (!applicants) return 0
  if (Array.isArray(applicants)) return applicants.length
  if (typeof applicants === 'object') return Object.keys(applicants as Record<string, unknown>).length
  return 1
}

function hasApplicants(service: ServiceList): boolean {
  return applicantsCount(service) > 0
}

function originKind(service: ServiceList): 'admin' | 'bot' | 'test' | 'driver' | 'unknown' {
  if (service.origin === Service.ORIGIN_TEST) return 'test'
  if (service.origin === Service.ORIGIN_DRIVER) return 'driver'
  if (service.origin === 'admin') return 'admin'
  if (service.origin === 'bot') return 'bot'
  if (service.created_by) return 'admin'
  if (service.wp_client_id) return 'bot'
  return 'unknown'
}

function originIcon(service: ServiceList): string {
  const kind = originKind(service)
  if (kind === 'test') return 'fa-flask'
  if (kind === 'bot') return 'fa-robot'
  if (kind === 'admin') return 'fa-desktop'
  if (kind === 'driver') return 'fa-mobile-screen'
  return 'fa-question'
}

function originTitle(service: ServiceList): string {
  return t('services.origin.' + originKind(service))
}

function startLocationName(service: ServiceList): string | undefined {
  const name = service.start_loc?.name
  return ServiceHelper.isSelfServiceStartLoc(name) ? t('services.self_service_trip') : name
}

function initials(name: string): string {
  return name
    .split(' ')
    .filter(word => word.length > 0)
    .slice(0, 2)
    .map(word => word[0])
    .join('')
    .toUpperCase()
}

function statusBadgeVariant(service: ServiceList): 'success' | 'danger' | 'info' | 'warning' {
  if (service.status === Service.STATUS_TERMINATED) return 'success'
  if (service.status === Service.STATUS_CANCELED) return 'danger'
  if (service.status === Service.STATUS_IN_PROGRESS) return 'info'
  return 'warning'
}

function getPaginatedData(data: []): void {
  paginatedServices.value = data
}

function paginatedData(page: number, next: boolean): void {
  const services = props.services;
  const cursor: ServiceCursor = {
    id: next ? services[services.length - 1].id : services[0].id,
    created: next ? services[services.length - 1].created_at : services[0].created_at,
  }
  emit('paginate', page, cursor, next)
}

function openStartLocationModal(service: ServiceList, event?: Event): void {
  if (props.table !== Tables.pendings) return
  hideTooltip(event)
  editingService.value = service
  newStartLocation.value = null
  startLocationFieldKey.value++
  placesStore.searchPlaces('', 10).then(updateAutocompletePlaces).catch(() => undefined)
  startLocationModal?.show()
}

function openCommentModal(service: ServiceList, event?: Event): void {
  if (props.table !== Tables.pendings) return
  hideTooltip(event)
  editingCommentService.value = service
  newComment.value = service.comment ?? ''
  commentModal?.show()
}

function updateAutocompletePlaces(from: Array<{ id?: string, key?: string, name: string }>): void {
  placesAutocomplete.value = from
    .map(place => ({
      id: place.key ?? place.id ?? '',
      value: place.name
    }))
    .filter(option => option.id !== '')
}

async function searchPlacesAutocomplete(term: string): Promise<Array<AutoCompleteType>> {
  const placesResult = await placesStore.searchPlaces(term, 10)
  updateAutocompletePlaces(placesResult)
  return placesAutocomplete.value
}

function onStartLocationChange(): void {
  newStartLocation.value = null
}

async function onStartLocationSelected(element: AutoCompleteType): Promise<void> {
  const place = await placesStore.findByName(element.value)
  if (!place || !branchSelected.value) return
  newStartLocation.value = {
    name: place.name,
    lat: place.lat,
    lng: place.lng,
    country: branchSelected.value.id,
    city: branchSelected.value.city.id
  }
}

function resetStartLocationForm(): void {
  newStartLocation.value = null
  editingService.value = null
  startLocationFieldKey.value++
}

function resetCommentForm(): void {
  newComment.value = ''
  editingCommentService.value = null
}

async function saveStartLocation(): Promise<void> {
  if (!editingService.value) return
  if (!newStartLocation.value) {
    await ToastService.toast(ToastService.ERROR, t('common.messages.error'), t('services.messages.no_start_loc'))
    return
  }
  if (!branchSelected.value) {
    await ToastService.toast(ToastService.ERROR, t('common.messages.error'), t('services.messages.branch_required'))
    return
  }
  isUpdatingStart.value = true
  ServiceRepository.updateStartLocation(editingService.value.id, newStartLocation.value)
    .then(async () => {
      if (editingService.value && newStartLocation.value) {
        editingService.value.start_loc = newStartLocation.value
      }
      startLocationModal?.hide()
      await ToastService.toast(ToastService.SUCCESS, t('services.messages.start_address_updated'))
    })
    .catch(async (e) => {
      await ToastService.toast(ToastService.ERROR, t('common.messages.error'), e.message)
    })
    .finally(() => {
      isUpdatingStart.value = false
    })
}

async function saveComment(): Promise<void> {
  if (!editingCommentService.value) return
  const targetService = editingCommentService.value
  isUpdatingComment.value = true
  const updatedComment = newComment.value.trim() || null
  ServiceRepository.updateComment(targetService.id, updatedComment)
    .then(async () => {
      targetService.comment = updatedComment
      commentModal?.hide()
      await ToastService.toast(ToastService.SUCCESS, t('services.messages.comment_updated'))
    })
    .catch(async (e) => {
      await ToastService.toast(ToastService.ERROR, t('common.messages.error'), e.message)
    })
    .finally(() => {
      isUpdatingComment.value = false
    })
}

function getTime(): void {
  paginatedServices.value.forEach(service => {
    service.a_go  = DateHelper.unix() - service.created_at
  })
}

function hideTooltip(event?: Event): void {
  const target = event?.currentTarget as HTMLElement | null
  if (!target) return
  const instance = Tooltip.getInstance(target) ?? Tooltip.getOrCreateInstance(target)
  instance.hide()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (props.table !== _unref(Tables).history)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("span", {
                class: "gorda-table-header-icon",
                style: _normalizeStyle({ background: headerConfig.value.gradient })
              }, [
                _createElementVNode("em", {
                  class: _normalizeClass(["fas", headerConfig.value.icon])
                }, null, 2)
              ], 4),
              _createElementVNode("h6", _hoisted_4, _toDisplayString(headerConfig.value.title), 1),
              _createElementVNode("span", _hoisted_5, _toDisplayString(props.services.length), 1)
            ]),
            _renderSlot(_ctx.$slots, "actions")
          ]))
        : _createCommentVNode("", true),
      (props.table === _unref(Tables).history && props.loading && paginatedServices.value.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _cache[1] || (_cache[1] = _createElementVNode("span", {
              class: "spinner-border spinner-border-sm text-secondary",
              role: "status",
              "aria-hidden": "true"
            }, null, -1)),
            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('common.messages.waiting')), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("table", _hoisted_9, [
          _cache[12] || (_cache[12] = _createElementVNode("caption", { hidden: "" }, null, -1)),
          _createElementVNode("thead", null, [
            _cache[2] || (_cache[2] = _createElementVNode("th", { class: "text-uppercase text-secondary text-xxs font-weight-bolder w-2" }, "#", -1)),
            _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t('services.fields.hour')), 1),
            _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t('services.fields.status')), 1),
            _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.$t('services.fields.start_address')), 1),
            (showDestination.value)
              ? (_openBlock(), _createElementBlock("th", _hoisted_13, _toDisplayString(_ctx.$t('services.fields.end_address')), 1))
              : _createCommentVNode("", true),
            _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.$t('services.fields.phone')), 1),
            _createElementVNode("th", _hoisted_15, _toDisplayString(_ctx.$t('services.fields.name')), 1),
            _createElementVNode("th", _hoisted_16, _toDisplayString(_ctx.$t('services.fields.comment')), 1),
            _createElementVNode("th", _hoisted_17, _toDisplayString(_ctx.$t('services.fields.origin')), 1),
            (showDriverColumn.value)
              ? (_openBlock(), _createElementBlock("th", _hoisted_18, _toDisplayString(_ctx.$t('services.fields.driver')), 1))
              : _createCommentVNode("", true),
            (showDriverNameColumn.value)
              ? (_openBlock(), _createElementBlock("th", _hoisted_19, _toDisplayString(_ctx.$t('services.fields.driver_name')), 1))
              : _createCommentVNode("", true),
            (showActionColumn.value)
              ? (_openBlock(), _createElementBlock("th", _hoisted_20))
              : _createCommentVNode("", true)
          ]),
          (paginatedServices.value.length > 0)
            ? (_openBlock(), _createElementBlock("tbody", {
                key: 0,
                class: _normalizeClass(["text-sm text-opacity-25", { 'gorda-table-body--loading': props.table === _unref(Tables).history && props.loading && paginatedServices.value.length > 0 }])
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedServices.value, (service, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: service.id
                  }, [
                    _createElementVNode("td", _hoisted_21, [
                      _createTextVNode(_toDisplayString(index + 1) + " ", 1),
                      (props.table === _unref(Tables).pendings && applicantsCount(service) > 0)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: "position-absolute top-0 start-75 badge font-weight-bolder rounded-circle bg-danger shadow",
                            style: {"z-index":"2"},
                            title: _ctx.$t('services.messages.has_applicants')
                          }, _toDisplayString(applicantsCount(service)), 9, _hoisted_22))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", _hoisted_23, _toDisplayString(props.table === _unref(Tables).history ? format(service.created_at) : _unref(DateHelper).aGo(service.a_go)), 1),
                    _createElementVNode("td", _hoisted_24, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["gorda-status-badge", 'gorda-status-badge--' + statusBadgeVariant(service)])
                      }, _toDisplayString(_ctx.$t('services.statuses.' + service.status)), 3)
                    ]),
                    _createElementVNode("td", _hoisted_25, [
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("span", {
                          class: "text-truncate",
                          style: {"max-width":"180px"},
                          title: startLocationName(service)
                        }, _toDisplayString(startLocationName(service)), 9, _hoisted_27),
                        (props.table === _unref(Tables).pendings)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "btn btn-link btn-sm text-secondary ms-2 p-0",
                              type: "button",
                              "data-bs-toggle": "tooltip",
                              "data-bs-placement": "top",
                              title: _ctx.$t('services.edit_start_address'),
                              onClick: ($event: any) => (openStartLocationModal(service, $event))
                            }, [...(_cache[3] || (_cache[3] = [
                              _createElementVNode("em", { class: "fas fa-pen" }, null, -1)
                            ]))], 8, _hoisted_28))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    (showDestination.value)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_29, _toDisplayString(service.end_loc?.name ?? 'N/A'), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("td", _hoisted_30, _toDisplayString(service.phone), 1),
                    _createElementVNode("td", _hoisted_31, [
                      (props.table !== _unref(Tables).history)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                            _createElementVNode("span", _hoisted_33, _toDisplayString(initials(service.name)), 1),
                            _createElementVNode("span", null, _toDisplayString(service.name), 1),
                            _createVNode(ClientCompletedBadge, {
                              count: service.client_completed_services_count
                            }, null, 8, ["count"])
                          ]))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(_toDisplayString(service.name) + " ", 1),
                            _createVNode(ClientCompletedBadge, {
                              count: service.client_completed_services_count
                            }, null, 8, ["count"])
                          ], 64))
                    ]),
                    _createElementVNode("td", _hoisted_34, [
                      _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("span", {
                          class: "text-truncate",
                          title: service.comment ?? 'N/A'
                        }, _toDisplayString(service.comment ?? 'N/A'), 9, _hoisted_36),
                        (props.table === _unref(Tables).pendings)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "btn btn-link btn-sm text-secondary ms-2 p-0",
                              type: "button",
                              "data-bs-toggle": "tooltip",
                              "data-bs-placement": "top",
                              title: _ctx.$t('services.edit_comment'),
                              onClick: ($event: any) => (openCommentModal(service, $event))
                            }, [...(_cache[4] || (_cache[4] = [
                              _createElementVNode("em", { class: "fas fa-pen" }, null, -1)
                            ]))], 8, _hoisted_37))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_38, [
                      _createElementVNode("em", {
                        class: _normalizeClass(["fa-solid", [originIcon(service), originKind(service) === 'test' ? 'text-warning' : originKind(service) === 'bot' ? 'text-success' : originKind(service) === 'admin' ? 'text-secondary' : originKind(service) === 'driver' ? 'text-primary' : 'text-muted']]),
                        "data-bs-toggle": "tooltip",
                        "data-bs-placement": "top",
                        title: originTitle(service)
                      }, null, 10, _hoisted_39)
                    ]),
                    (showDriverColumn.value && service.driver)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_40, [
                          _createElementVNode("div", _hoisted_41, [
                            _createElementVNode("div", null, [
                              _createElementVNode("img", {
                                src: service.driver.photoUrl,
                                class: "avatar avatar-sm my-0 me-3",
                                alt: "Profile"
                              }, null, 8, _hoisted_42)
                            ]),
                            _createElementVNode("div", _hoisted_43, [
                              _createElementVNode("h6", _hoisted_44, _toDisplayString(_unref(ServiceHelper).vehiclePlate(service)), 1),
                              _createElementVNode("p", _hoisted_45, _toDisplayString(service.driver.phone), 1)
                            ])
                          ])
                        ]))
                      : (showDriverColumn.value)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_46))
                        : _createCommentVNode("", true),
                    (showDriverNameColumn.value && service.driver)
                      ? (_openBlock(), _createElementBlock("td", {
                          key: 3,
                          class: "py-1 text-truncate",
                          style: {"max-width":"100px"},
                          "data-bs-target": "tooltip",
                          title: service.driver.name,
                          "data-bs-placement": "top"
                        }, _toDisplayString(service.driver.name), 9, _hoisted_47))
                      : (showDriverNameColumn.value)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_48))
                        : _createCommentVNode("", true),
                    (showActionColumn.value)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_49, [
                          (props.table !== _unref(Tables).history)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "btn btn-sm btn-danger btn-rounded py-1 px-2 mx-1 my-0",
                                onClick: ($event: any) => (cancel(service, $event)),
                                "data-bs-toggle": "tooltip",
                                "data-bs-placement": "top",
                                title: _ctx.$t('common.actions.cancel')
                              }, [...(_cache[5] || (_cache[5] = [
                                _createElementVNode("em", { class: "fas fa-ban" }, null, -1)
                              ]))], 8, _hoisted_50))
                            : _createCommentVNode("", true),
                          (props.table === _unref(Tables).pendings && !service.driver_id)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                class: "btn btn-sm btn-info btn-rounded py-1 px-2 mx-1 my-0",
                                onClick: ($event: any) => (restart(service, $event)),
                                "data-bs-toggle": "tooltip",
                                "data-bs-placement": "top",
                                title: _ctx.$t('common.actions.restart'),
                                disabled: hasApplicants(service)
                              }, [...(_cache[6] || (_cache[6] = [
                                _createElementVNode("em", { class: "fas fa-rotate-left" }, null, -1)
                              ]))], 8, _hoisted_51))
                            : _createCommentVNode("", true),
                          (service.isPending() && props.table !== _unref(Tables).history)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 2,
                                class: "btn btn-sm btn-secondary btn-rounded py-1 px-2 mx-1 my-0",
                                "data-bs-placement": "top",
                                title: _ctx.$t('common.actions.assign'),
                                "data-bs-toggle": "modal",
                                id: service.id,
                                "data-bs-target": "#driverModal"
                              }, [...(_cache[7] || (_cache[7] = [
                                _createElementVNode("em", { class: "fas fa-car" }, null, -1)
                              ]))], 8, _hoisted_52))
                            : _createCommentVNode("", true),
                          (service.isInProgress() && props.table !== _unref(Tables).history)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 3,
                                class: "btn btn-sm btn-dark btn-rounded py-1 px-2 mx-1 my-0",
                                onClick: ($event: any) => (release(service, $event)),
                                "data-bs-toggle": "tooltip",
                                "data-bs-placement": "top",
                                title: _ctx.$t('common.actions.release')
                              }, [...(_cache[8] || (_cache[8] = [
                                _createElementVNode("em", { class: "fas fa-car-crash" }, null, -1)
                              ]))], 8, _hoisted_53))
                            : _createCommentVNode("", true),
                          (service.isInProgress() && props.table !== _unref(Tables).history)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 4,
                                class: "btn btn-sm btn-dark btn-rounded py-1 px-2 mx-1 my-0",
                                onClick: ($event: any) => (end(service, $event)),
                                "data-bs-toggle": "tooltip",
                                "data-bs-placement": "top",
                                title: _ctx.$t('common.actions.terminate')
                              }, [...(_cache[9] || (_cache[9] = [
                                _createElementVNode("em", { class: "fas fa-check" }, null, -1)
                              ]))], 8, _hoisted_54))
                            : _createCommentVNode("", true),
                          (props.table === _unref(Tables).history)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 5,
                                class: "btn btn-sm btn-dark btn-rounded py-1 px-2 mx-1 my-0",
                                onClick: ($event: any) => (show(service)),
                                title: _ctx.$t('common.actions.see')
                              }, [...(_cache[10] || (_cache[10] = [
                                _createElementVNode("em", { class: "fas fa-eye" }, null, -1)
                              ]))], 8, _hoisted_55))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ], 2))
            : (props.table === _unref(Tables).history && props.loading)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_56, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", {
                      colspan: visibleColumnCount.value,
                      class: "text-center py-4 text-secondary text-sm"
                    }, [
                      _cache[11] || (_cache[11] = _createElementVNode("em", { class: "fas fa-circle-notch fa-spin me-1" }, null, -1)),
                      _createTextVNode(_toDisplayString(_ctx.$t('common.messages.waiting')), 1)
                    ], 8, _hoisted_57)
                  ])
                ]))
              : _createCommentVNode("", true)
        ]),
        (props.table === _unref(Tables).history)
          ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
              _createVNode(DBPaginator, {
                pagination: props.pagination,
                onPaginatedData: paginatedData
              }, null, 8, ["pagination"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_59, [
              _createVNode(_unref(Paginator), {
                data: props.services,
                perPage: __props.pagination.perPage,
                onPaginatedData: getPaginatedData
              }, null, 8, ["data", "perPage"])
            ]))
      ])
    ]),
    _createElementVNode("div", {
      class: "modal fade",
      id: "editStartLocationModal",
      tabindex: "-1",
      "aria-hidden": "true",
      ref_key: "startLocationModalRef",
      ref: startLocationModalRef
    }, [
      _createElementVNode("div", _hoisted_60, [
        _createElementVNode("div", _hoisted_61, [
          _createElementVNode("div", _hoisted_62, [
            _createElementVNode("h5", _hoisted_63, _toDisplayString(_ctx.$t('services.edit_start_address')), 1),
            _cache[13] || (_cache[13] = _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            }, null, -1))
          ]),
          _createElementVNode("div", _hoisted_64, [
            _createElementVNode("p", _hoisted_65, _toDisplayString(_ctx.$t('services.current_start_address')), 1),
            _createElementVNode("p", _hoisted_66, _toDisplayString(currentStartAddress.value), 1),
            (_openBlock(), _createBlock(AutoComplete, {
              key: startLocationFieldKey.value,
              idField: 'edit-start-' + (editingService.value?.id ?? ''),
              fieldName: 'start_address_edit',
              elements: placesAutocomplete.value,
              "search-handler": searchPlacesAutocomplete,
              placeholder: _ctx.$t('common.placeholders.address'),
              classes: 'form-control',
              disabled: !_unref(placesReady),
              onSelected: onStartLocationSelected,
              onOnChange: onStartLocationChange
            }, null, 8, ["idField", "elements", "placeholder", "disabled"]))
          ]),
          _createElementVNode("div", _hoisted_67, [
            _createElementVNode("button", _hoisted_68, _toDisplayString(_ctx.$t('common.actions.close')), 1),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              disabled: !newStartLocation.value || isUpdatingStart.value,
              onClick: saveStartLocation
            }, [
              (isUpdatingStart.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_70))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('common.actions.edit')), 1)
            ], 8, _hoisted_69)
          ])
        ])
      ])
    ], 512),
    _createElementVNode("div", {
      class: "modal fade",
      id: "editCommentModal",
      tabindex: "-1",
      "aria-hidden": "true",
      ref_key: "commentModalRef",
      ref: commentModalRef
    }, [
      _createElementVNode("div", _hoisted_71, [
        _createElementVNode("div", _hoisted_72, [
          _createElementVNode("div", _hoisted_73, [
            _createElementVNode("h5", _hoisted_74, _toDisplayString(_ctx.$t('services.edit_comment')), 1),
            _cache[14] || (_cache[14] = _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            }, null, -1))
          ]),
          _createElementVNode("div", _hoisted_75, [
            _createElementVNode("p", _hoisted_76, _toDisplayString(_ctx.$t('services.current_comment')), 1),
            _createElementVNode("p", _hoisted_77, _toDisplayString(currentComment.value), 1),
            _withDirectives(_createElementVNode("textarea", {
              class: "form-control",
              rows: "3",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newComment).value = $event)),
              placeholder: _ctx.$t('common.placeholders.comment')
            }, null, 8, _hoisted_78), [
              [_vModelText, newComment.value]
            ])
          ]),
          _createElementVNode("div", _hoisted_79, [
            _createElementVNode("button", _hoisted_80, _toDisplayString(_ctx.$t('common.actions.close')), 1),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary",
              disabled: isUpdatingComment.value,
              onClick: saveComment
            }, [
              (isUpdatingComment.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_82))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('common.actions.edit')), 1)
            ], 8, _hoisted_81)
          ])
        ])
      ])
    ], 512)
  ], 64))
}
}

})